import { Box, Drawer, Link, Typography } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import * as React from 'react';
import SidebarListMenuItems from 'features/sidebar/components/sidebar-list-menu-items';
import useAuth from 'features/auth/hooks/use-auth';
import { getPartnerLogo } from 'utils/get-partner-logo.util';
import { PartnerNameEnum } from 'shared/enums/partner-name-enum';
import { PermissionsAdminEnum } from 'features/auth/enums/permissions-admin.enum';
import { useSelector } from 'react-redux';
import { StoreState } from 'store';

type Props = {
  openSidebar: boolean;
  width: number;
};
const Sidebar: React.FC<Props> = (props) => {
  const { state } = useAuth();
  const { permissions } = useSelector((state: StoreState) => state.auth);

  const hasDocumentationPermission = permissions.includes(
    PermissionsAdminEnum.API_DOCUMENTATION_LINK
  );
  const documentationUrl = process.env.REACT_APP_API_DOCUMENTATION_URL;

  return (
    <Drawer
      variant="persistent"
      open={props.openSidebar}
      sx={{
        top: 64,
        width: props.width,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: props.width,
          boxSizing: 'border-box',
          zIndex: 998,
          top: 64,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          maxHeight: 'calc(100vh - 64px)',
        },
      }}
    >
      <Box>
        {state.partner && (
          <Box
            display="flex"
            justifyContent="center"
            maxHeight="80px"
            maxWidth={
              state.partner === PartnerNameEnum.GCASH_LENDING ||
              state.partner === PartnerNameEnum.GCASH_MERCHANTS
                ? '240px'
                : '150px'
            }
            m="24px 0 0 16px"
          >
            <img
              style={{
                width: 'auto',
                height: 'auto',
                maxWidth: ' 100%',
                maxHeight: ' 100%',
              }}
              src={getPartnerLogo(state.partner)}
              alt="logo"
            />
          </Box>
        )}
        <SidebarListMenuItems openSidebar={props.openSidebar} />
      </Box>
      {hasDocumentationPermission && documentationUrl && (
        <Box
          sx={{ padding: '10px', borderTop: '1px solid rgba(0, 0, 0, 0.08)' }}
        >
          <Link
            href={documentationUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              marginTop: 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px',
              borderRadius: '4px',
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              textDecorationColor: 'currentcolor',
            }}
          >
            <LaunchIcon color={'action'} />
            <Typography
              sx={{
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '150%',
                letterSpacing: '0.15px',
              }}
            >
              API Documentation
            </Typography>
          </Link>
        </Box>
      )}
    </Drawer>
  );
};
export default Sidebar;
